export class UserModel {
    public AccountId: number;
    public Id: number;
    public IsActive: boolean;
    public IsSendCreds: boolean;
    public IsDeleted: boolean;
    public CreatedDate: string;
    public LastUpdatedDate: string;
    public FirstName: string;
    public LastName: string;
    public Mobile: string;
    public PhoneNumber: string;
    public UserName: string;
    public RoleId: number;
    public EmailAddress: string;
    public Password: string;
    public PasswordReType: string;
    public DepartmentId: number = 0;
    public Role: any = {
        Name: '',
        Description: ''
    };

    public IsActivityAdmin: boolean;
    public IsAdministrationAdmin: boolean;

    public Resending: boolean = false;
    public IsUpdate: boolean;
    public UpdateRoleOnly: boolean = false;
    public EnablePopupMobileMessage: boolean = false
}



// WEBPACK FOOTER //
// ./src/app/models/UserModel.ts